(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[191],{

/***/ 47443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 1196:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 20731:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(1196),
    arrayMap = __webpack_require__(29932),
    baseUnary = __webpack_require__(7518),
    cacheHas = __webpack_require__(74757);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),

/***/ 41848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 42118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIsNaN = __webpack_require__(62722),
    strictIndexOf = __webpack_require__(42351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 62722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 5976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 42351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 50361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ 29246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612),
    isObjectLike = __webpack_require__(37005);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 14293:
/***/ (function(module) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ 82569:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseDifference = __webpack_require__(20731),
    baseRest = __webpack_require__(5976),
    isArrayLikeObject = __webpack_require__(29246);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),

/***/ 75023:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(70655);
const react_1 = (0, tslib_1.__importDefault)(__webpack_require__(67294));
const isArray_1 = (0, tslib_1.__importDefault)(__webpack_require__(1469));
const without_1 = (0, tslib_1.__importDefault)(__webpack_require__(82569));
const Object_1 = (0, tslib_1.__importDefault)(__webpack_require__(90250));
const Field_1 = (0, tslib_1.__importDefault)(__webpack_require__(82125));
const Contexts_1 = __webpack_require__(44017);
const defaultProps = {
    addLabel: 'Add',
    removeLabel: 'Remove',
    errorMessages: {},
    autoAddItem: false,
    showAddButton: true,
    showRemoveButton: true,
    renderProps: false
};
class ArrayComponent extends react_1.default.Component {
    addItem(itemValue = {}) {
        var newArray = this.props.value;
        if ((0, isArray_1.default)(newArray)) {
            newArray.push(itemValue);
        }
        else {
            newArray = [itemValue];
        }
        this.props.onChange(newArray);
    }
    getObjectField() {
        return Object_1.default;
    }
    removeItem(index) {
        const value = this.props.value || [];
        var newArray = (0, without_1.default)(value, value[index]);
        this.props.onChange(newArray);
    }
    getChildrenComponents(item, index) {
        if (this.props.renderItem)
            return this.props.renderItem(item, index);
        if (this.props.children)
            return this.props.children;
    }
    renderChildren() {
        const value = this.props.value || [];
        if (this.props.autoAddItem && !this.props.disabled && value.length === 0) {
            value.push({});
        }
        return value.map((item, index) => {
            const children = this.getChildrenComponents(item, index);
            return this.renderChildrenItem({ index, children });
        });
    }
    renderChildrenItem({ index, children }) {
        const button = this.props.showRemoveButton
            ? this.renderButton(() => this.removeItem(index), this.props.removeLabel, 'srf_removeButton')
            : null;
        return (react_1.default.createElement("div", { style: { marginTop: 20, marginBottom: 20, padding: 20 }, key: `${this.props.fieldName}.${index}` },
            this.renderChildrenItemWithContext({ index, children }),
            button));
    }
    renderChildrenItemWithContext({ index, children }) {
        return (react_1.default.createElement(Contexts_1.ParentFieldNameContext.Provider, { key: index, value: this.props.fieldName },
            react_1.default.createElement(Field_1.default, { fieldName: `${index}`, type: this.getObjectField() }, this.props.renderProps ? children(index) : children)));
    }
    renderButton(onClick, label, className) {
        return (react_1.default.createElement("div", { style: { marginTop: 10 } },
            react_1.default.createElement("button", { type: "button", className: className, onClick: onClick }, label)));
    }
    renderErrorMessage() {
        if (!this.props.errorMessage)
            return;
        return (react_1.default.createElement("div", { style: { color: 'red' }, className: "srf_errorMessage" }, this.props.errorMessage));
    }
    render() {
        return (react_1.default.createElement("div", { className: "srf-array-container", style: { marginTop: 20 } },
            react_1.default.createElement("div", null,
                react_1.default.createElement("b", null, this.props.label)),
            this.renderErrorMessage(),
            this.renderChildren(),
            this.props.showAddButton
                ? this.renderButton(() => this.addItem(), this.props.addLabel, 'srf_addButton')
                : null));
    }
}
exports["default"] = ArrayComponent;
ArrayComponent.defaultProps = defaultProps;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 44017:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ParentFieldNameContext = exports.OnChangeContext = exports.ErrorMessagesContext = exports.ValueContext = void 0;
const tslib_1 = __webpack_require__(70655);
const react_1 = (0, tslib_1.__importDefault)(__webpack_require__(67294));
const ValueContext = react_1.default.createContext({});
exports.ValueContext = ValueContext;
const ParentFieldNameContext = react_1.default.createContext(null);
exports.ParentFieldNameContext = ParentFieldNameContext;
const ErrorMessagesContext = react_1.default.createContext({});
exports.ErrorMessagesContext = ErrorMessagesContext;
const OnChangeContext = react_1.default.createContext((fieldName, fieldValue) => { });
exports.OnChangeContext = OnChangeContext;
//# sourceMappingURL=Contexts.js.map

/***/ }),

/***/ 82125:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(70655);
const react_1 = (0, tslib_1.__importDefault)(__webpack_require__(67294));
const omit_1 = (0, tslib_1.__importDefault)(__webpack_require__(82723));
const keys_1 = (0, tslib_1.__importDefault)(__webpack_require__(3674));
const get_1 = (0, tslib_1.__importDefault)(__webpack_require__(27361));
const Contexts_1 = __webpack_require__(44017);
const types_1 = __webpack_require__(2727);
const lodash_1 = __webpack_require__(96486);
class Field extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.focus = () => {
            if (!this.input.focus) {
                throw new Error("Field doesn't has a focus method");
            }
            this.input.focus();
        };
    }
    getFieldName(parentFieldName) {
        if (parentFieldName) {
            if (this.props.fieldName) {
                return `${parentFieldName}.${this.props.fieldName}`;
            }
            else {
                return parentFieldName;
            }
        }
        else {
            return this.props.fieldName;
        }
    }
    getComponent() {
        return this.props.type;
    }
    getErrorMessage(errorMessages, parentFieldName) {
        return (this.props.errorMessage ||
            errorMessages[this.getFieldName(parentFieldName)] ||
            (0, get_1.default)(errorMessages, this.getFieldName(parentFieldName)));
    }
    getChildProps({ value, parentFieldName, onChange, errorMessages }) {
        const fieldComponent = this.getComponent();
        const propOptions = (0, omit_1.default)(this.props, ['fieldName', 'type', 'errorMessage']);
        const allowedKeys = (0, lodash_1.union)((0, keys_1.default)({ ...fieldComponent.propTypes }), types_1.fieldPropsKeys);
        allowedKeys.push('type');
        const notDefinedOptions = (0, omit_1.default)(propOptions, allowedKeys);
        const props = {
            value: (0, get_1.default)(value || {}, this.props.fieldName),
            parentValue: value || {},
            onChange: newValue => onChange(this.getFieldName(parentFieldName), newValue),
            errorMessage: this.getErrorMessage(errorMessages || {}, parentFieldName),
            fieldName: this.getFieldName(parentFieldName),
            passProps: notDefinedOptions,
            ...propOptions
        };
        return props;
    }
    renderComponent(info) {
        const Component = this.getComponent();
        const props = this.getChildProps(info);
        const ref = Component.prototype.render ? { ref: input => (this.input = input) } : {};
        return (react_1.default.createElement(Contexts_1.ValueContext.Provider, { value: props.value },
            react_1.default.createElement(Component, { ...ref, ...props })));
    }
    render() {
        return (react_1.default.createElement(Contexts_1.ValueContext.Consumer, null, value => (react_1.default.createElement(Contexts_1.ErrorMessagesContext.Consumer, null, errorMessages => (react_1.default.createElement(Contexts_1.OnChangeContext.Consumer, null, onChange => (react_1.default.createElement(Contexts_1.ParentFieldNameContext.Consumer, null, parentFieldName => this.renderComponent({
            value,
            parentFieldName,
            onChange,
            errorMessages
        })))))))));
    }
}
exports["default"] = Field;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 15227:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(70655);
const cloneDeep_1 = (0, tslib_1.__importDefault)(__webpack_require__(50361));
const isPlainObject_1 = (0, tslib_1.__importDefault)(__webpack_require__(68630));
const isNil_1 = (0, tslib_1.__importDefault)(__webpack_require__(14293));
const setValue = function (value, keyParts, fieldValue) {
    const key = keyParts.shift();
    if (keyParts.length === 0) {
        value[key] = fieldValue;
    }
    else {
        if (!isNaN(keyParts[0])) {
            if ((0, isNil_1.default)(value[key])) {
                value[key] = [];
            }
        }
        else {
            if ((0, isNil_1.default)(value[key])) {
                value[key] = {};
            }
            if (!(0, isPlainObject_1.default)(value[key])) {
                throw new Error(`Expected plain object for key ${key}`);
            }
        }
        setValue(value[key], keyParts, fieldValue);
    }
};
function default_1(val, fieldName, fieldValue) {
    const value = (0, cloneDeep_1.default)(val);
    const keyParts = fieldName.split('.');
    setValue(value, keyParts, fieldValue);
    return value;
}
exports["default"] = default_1;
//# sourceMappingURL=getNewValue.js.map

/***/ }),

/***/ 8543:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(70655);
const react_1 = (0, tslib_1.__importStar)(__webpack_require__(67294));
const omit_1 = (0, tslib_1.__importDefault)(__webpack_require__(82723));
const isFunction_1 = (0, tslib_1.__importDefault)(__webpack_require__(23560));
const getNewValue_1 = (0, tslib_1.__importDefault)(__webpack_require__(15227));
const isReactNative_1 = (0, tslib_1.__importDefault)(__webpack_require__(29953));
const Contexts_1 = __webpack_require__(44017);
const cloneDeep_1 = (0, tslib_1.__importDefault)(__webpack_require__(50361));
const lodash_1 = __webpack_require__(96486);
const use_deep_compare_effect_1 = (0, tslib_1.__importDefault)(__webpack_require__(87620));
function Form(props, ref) {
    const [state, setState] = (0, react_1.useState)((0, cloneDeep_1.default)(props.state) || {});
    const resetState = () => {
        setState((0, cloneDeep_1.default)(props.state));
    };
    (0, use_deep_compare_effect_1.default)(() => {
        if (!(0, lodash_1.isNil)(props.state)) {
            resetState();
        }
    }, [props.state || {}]);
    const onChange = (fieldName, fieldValue) => {
        const value = (0, getNewValue_1.default)(state, fieldName, fieldValue);
        setState(value);
        if (props.onChange) {
            props.onChange(value);
        }
    };
    const submit = () => {
        if (!(0, isFunction_1.default)(props.onSubmit)) {
            console.warn('You should pass a onSubmit prop to this form');
            return;
        }
        return props.onSubmit(state);
    };
    const onFormSubmit = (event) => {
        event.preventDefault();
        return submit();
    };
    (0, react_1.useImperativeHandle)(ref, () => ({
        submit,
        getValue: () => state
    }));
    const renderChild = () => {
        const domProps = (0, omit_1.default)(props, 'children', 'state', 'onChange', 'errorMessages', 'useFormTag', 'onSubmit');
        if ((0, isReactNative_1.default)()) {
            return props.children;
        }
        if (props.useFormTag !== false) {
            return (react_1.default.createElement("form", { ...domProps, onSubmit: onFormSubmit }, props.children));
        }
        else {
            return props.children;
        }
    };
    return (react_1.default.createElement(Contexts_1.ParentFieldNameContext.Provider, { value: null },
        react_1.default.createElement(Contexts_1.ErrorMessagesContext.Provider, { value: props.errorMessages },
            react_1.default.createElement(Contexts_1.OnChangeContext.Provider, { value: onChange },
                react_1.default.createElement(Contexts_1.ValueContext.Provider, { value: state }, renderChild())))));
}
exports["default"] = (0, react_1.forwardRef)(Form);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 90250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(70655);
const react_1 = (0, tslib_1.__importDefault)(__webpack_require__(67294));
const Contexts_1 = __webpack_require__(44017);
class ObjectComponent extends react_1.default.Component {
    getChildrenComponents() {
        return this.renderChildrenComponent();
    }
    renderChildrenComponent() {
        return (react_1.default.createElement(Contexts_1.ParentFieldNameContext.Provider, { value: this.props.fieldName }, this.props.children));
    }
    renderErrorMessage() {
        if (!this.props.errorMessage)
            return;
        return (react_1.default.createElement("div", { style: { color: 'red' }, className: "srf_errorMessage" }, this.props.errorMessage));
    }
    render() {
        return (react_1.default.createElement("div", { style: { marginTop: 20, marginBottom: 20, padding: 20 } },
            react_1.default.createElement("div", null,
                react_1.default.createElement("b", null, this.props.label)),
            this.renderErrorMessage(),
            this.getChildrenComponents()));
    }
}
exports["default"] = ObjectComponent;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 46044:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(70655);
const react_1 = (0, tslib_1.__importDefault)(__webpack_require__(67294));
const prop_types_1 = (0, tslib_1.__importDefault)(__webpack_require__(45697));
const Contexts_1 = __webpack_require__(44017);
class WithValue extends react_1.default.Component {
    render() {
        return react_1.default.createElement(Contexts_1.ValueContext.Consumer, null, value => this.props.children(value));
    }
}
exports["default"] = WithValue;
WithValue.propTypes = {
    children: prop_types_1.default.func
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 40191:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ParentFieldNameContext = exports.OnChangeContext = exports.ErrorMessagesContext = exports.ValueContext = exports.useValue = exports.WithValue = exports.ObjectComponent = exports.ArrayComponent = exports.Field = exports.Form = void 0;
const tslib_1 = __webpack_require__(70655);
const Form_1 = (0, tslib_1.__importDefault)(__webpack_require__(8543));
exports.Form = Form_1.default;
const Field_1 = (0, tslib_1.__importDefault)(__webpack_require__(82125));
exports.Field = Field_1.default;
const Array_1 = (0, tslib_1.__importDefault)(__webpack_require__(75023));
exports.ArrayComponent = Array_1.default;
const Object_1 = (0, tslib_1.__importDefault)(__webpack_require__(90250));
exports.ObjectComponent = Object_1.default;
const WithValue_1 = (0, tslib_1.__importDefault)(__webpack_require__(46044));
exports.WithValue = WithValue_1.default;
const useValue_1 = (0, tslib_1.__importDefault)(__webpack_require__(21637));
exports.useValue = useValue_1.default;
const Contexts_1 = __webpack_require__(44017);
Object.defineProperty(exports, "ValueContext", ({ enumerable: true, get: function () { return Contexts_1.ValueContext; } }));
Object.defineProperty(exports, "ErrorMessagesContext", ({ enumerable: true, get: function () { return Contexts_1.ErrorMessagesContext; } }));
Object.defineProperty(exports, "OnChangeContext", ({ enumerable: true, get: function () { return Contexts_1.OnChangeContext; } }));
Object.defineProperty(exports, "ParentFieldNameContext", ({ enumerable: true, get: function () { return Contexts_1.ParentFieldNameContext; } }));
(0, tslib_1.__exportStar)(__webpack_require__(2727), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2727:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fieldPropsKeys = void 0;
exports.fieldPropsKeys = [
    'fieldName',
    'type',
    'value',
    'label',
    'errorMessage',
    'onChange',
    'disabled',
    'fieldSchema',
    'schema',
    'passProps'
];
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 21637:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(67294);
const Contexts_1 = __webpack_require__(44017);
function useValue() {
    return (0, react_1.useContext)(Contexts_1.ValueContext);
}
exports["default"] = useValue;
//# sourceMappingURL=useValue.js.map

/***/ }),

/***/ 29953:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function default_1() {
    return typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
}
exports["default"] = default_1;
//# sourceMappingURL=isReactNative.js.map

/***/ }),

/***/ 87620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ useDeepCompareEffect; },
  "useDeepCompareEffectNoCheck": function() { return /* binding */ useDeepCompareEffectNoCheck; },
  "useDeepCompareMemoize": function() { return /* binding */ useDeepCompareMemoize; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/dequal/dist/index.mjs
var has = Object.prototype.hasOwnProperty;

function find(iter, tar, key) {
	for (key of iter.keys()) {
		if (dequal(key, tar)) return key;
	}
}

function dequal(foo, bar) {
	var ctor, len, tmp;
	if (foo === bar) return true;

	if (foo && bar && (ctor=foo.constructor) === bar.constructor) {
		if (ctor === Date) return foo.getTime() === bar.getTime();
		if (ctor === RegExp) return foo.toString() === bar.toString();

		if (ctor === Array) {
			if ((len=foo.length) === bar.length) {
				while (len-- && dequal(foo[len], bar[len]));
			}
			return len === -1;
		}

		if (ctor === Set) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len;
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!bar.has(tmp)) return false;
			}
			return true;
		}

		if (ctor === Map) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len[0];
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!dequal(len[1], bar.get(tmp))) {
					return false;
				}
			}
			return true;
		}

		if (ctor === ArrayBuffer) {
			foo = new Uint8Array(foo);
			bar = new Uint8Array(bar);
		} else if (ctor === DataView) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo.getInt8(len) === bar.getInt8(len));
			}
			return len === -1;
		}

		if (ArrayBuffer.isView(foo)) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo[len] === bar[len]);
			}
			return len === -1;
		}

		if (!ctor || typeof foo === 'object') {
			len = 0;
			for (ctor in foo) {
				if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
				if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
			}
			return Object.keys(bar).length === len;
		}
	}

	return foo !== foo && bar !== bar;
}

;// CONCATENATED MODULE: ./node_modules/use-deep-compare-effect/dist/use-deep-compare-effect.esm.js



function checkDeps(deps) {
  if (!deps || !deps.length) {
    throw new Error('useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.');
  }

  if (deps.every(isPrimitive)) {
    throw new Error('useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.');
  }
}

function isPrimitive(val) {
  return val == null || /^[sbn]/.test(typeof val);
}
/**
 * @param value the value to be memoized (usually a dependency list)
 * @returns a momoized version of the value as long as it remains deeply equal
 */


function useDeepCompareMemoize(value) {
  var ref = react.useRef(value);
  var signalRef = react.useRef(0);

  if (!dequal(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  } // eslint-disable-next-line react-hooks/exhaustive-deps


  return react.useMemo(function () {
    return ref.current;
  }, [signalRef.current]);
}

function useDeepCompareEffect(callback, dependencies) {
  if (false) {} // eslint-disable-next-line react-hooks/exhaustive-deps


  return react.useEffect(callback, useDeepCompareMemoize(dependencies));
}

function useDeepCompareEffectNoCheck(callback, dependencies) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return react.useEffect(callback, useDeepCompareMemoize(dependencies));
}




/***/ })

}]);